import dayjs from '@/services/date'
import { DurationUnits } from '@/shared/constants/date/DurationUnits'

export default function hasPassedTimeToday(time, timezone) {
  const now = dayjs().tz(timezone)
  const timeToday = now.startOf(DurationUnits.DAY).add(time)

  return now.isAfter(timeToday)
}
